import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { HttpClientModule } from '@angular/common/http';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';

import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateConfigService } from './translate-config.service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
// import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
// import { WonderPush } from '@awesome-cordova-plugins/wonderpush/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { AnalyticsService } from './services/analytics/analytics.service';

import { AutoCompleteModule } from 'ionic4-auto-complete';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';

import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular-ivy';
import { BrowserTracing } from '@sentry/tracing';

import { SharedModule } from './shared/shared.module';
import { SentryService } from './services/sentry.service'; // Custom wrapper service

export function LanguageLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

Sentry.init(
  {
    dsn: "https://08f24d3d804be48f0d5c0e7265c90361@o4509721929711616.ingest.us.sentry.io/4509721936134144",
    // To set your release and dist versions
    release: 'Agrizy-ionic-internal@' + '1.5.62',
    dist: '1',
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // We recommend adjusting this value in production.
    tracesSampleRate: 1.0,
    integrations: [
      new BrowserTracing({
        tracingOrigins: ['localhost', 'https://api.agrizy.in/'],
      }) as any,
    ]
  },
  // Forward the init method from @sentry/angular
  SentryAngular.init
);

@NgModule({
  declarations: [
    AppComponent,
    // AutoCompleteModule
  ],
  imports: [BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    TranslateModule,
    // AutoCompleteModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (LanguageLoader),
        deps: [HttpClient]
      }
    }),
    SharedModule
  ],
  providers: [
    TranslateConfigService, InAppBrowser, WebView,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: ErrorHandler,
      // Attach the Sentry ErrorHandler
      useValue: SentryAngular.createErrorHandler(),
    },
    HTTP,
    LocationAccuracy,
    Geolocation,
    SocialSharing,
    // WonderPush,
    AndroidPermissions,
    AnalyticsService,
    SentryService,
    SplashScreen
  ],
  exports: [],

  bootstrap: [AppComponent],
})
export class AppModule { }